export default "__VITE_ASSET__5ea3cfbc__"